import { useConfig } from '@cp/shared/config';
import { useClientProfile } from 'src/entities/client';
import { isWorkingRulesOnboardingRequired } from './isWorkingRulesOnboardingRequired';

/** Reactive variant of {@link isWorkingRulesOnboardingRequired} for the current client. */
export const useIsNeedWorkingRulesOnboarding = () => {
  const config = useConfig();
  const profile = useClientProfile();

  return isWorkingRulesOnboardingRequired(profile, { isSkipped: Boolean(config.get('SKIP_WORKING_RULES_ONBOARDING', false)) });
};
